import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { HdfsLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(HdfsLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                url: '*',
                authenticationType: '*',
                userName: '*',
                password: 'secret',
                encryptedCredential: '*'
            }
        }
    }
})
export class HdfsLinkedServiceAdapter extends LinkedServiceAdapter<HdfsLinkedService> {
    protected modelConstructor(): new () => HdfsLinkedService {
        return HdfsLinkedService;
    }

    protected model(): IModel {
        return HdfsLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: HdfsLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.HdfsLinkedService;

        properties.type = Metamodel.modelFor(HdfsLinkedService).name;

        properties.typeProperties = {
            url: linkedService.url,
            authenticationType: linkedService.authenticationType,
            userName: linkedService.userName || undefined,
            password: (linkedService.authenticationType === 'Windows') ? passwordOrAKVtoSecretBase(linkedService.password, this.context) : undefined
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: HdfsLinkedService): Promise<HdfsLinkedService> {
        const properties = linkedServiceResource.properties as Model.HdfsLinkedService;

        if (properties != null && properties.typeProperties != null) {
            linkedService.url = properties.typeProperties.url;
            linkedService.authenticationType = properties.typeProperties.authenticationType;
            linkedService.userName = properties.typeProperties.userName;
            linkedService.password = secretBaseToPasswordOrAKV(properties.typeProperties.password, properties.typeProperties.authenticationType === 'Windows', this.context);
        }

        return linkedService;
    }
}
